import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const editAmpCategory = (categoryId, data) => request.put(`${API_BASE_URL}/blockchain/category/${categoryId}`, data)

export default editAmpCategory